"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Helpers {
    static replaceAll(value, substring, replacement) {
        if (Object.prototype.hasOwnProperty.call(String.prototype, 'replaceAll')) {
            return value.replaceAll(substring, replacement);
        }
        return this.replaceAllPolyFill(value, substring, replacement);
    }
    static replaceAllPolyFill(value, substring, replacement) {
        return value.replace(new RegExp(this.escape(substring), 'g'), replacement);
    }
    static escape(value) {
        if (typeof value !== 'string') {
            return value;
        }
        return value.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
}
exports.default = Helpers;
//# sourceMappingURL=helpers.js.map